import { forwardRef } from 'react';
import Text from '../Text';
import SwitchWrapper from './style/switcherWrapper';

const Switcher = forwardRef(
  ({ label, error, className, disabled, 'aria-label': ariaLabel, ...rest }, ref) => (
    <SwitchWrapper className={`${className || ''}`}>
      {label && (
        <Text size='MD' className='label-text'>
          {label}
        </Text>
      )}
      <input
        {...rest}
        ref={ref}
        type='checkbox'
        disabled={disabled}
        aria-label={label || ariaLabel || 'Toggle'}
      />
      <span className='slider' />
      {error && <span className='error-message'>{error}</span>}
    </SwitchWrapper>
  )
);

Switcher.displayName = 'InputSwitch';
export default Switcher;
